import type { EverflowConvertEventParams } from "@/features/analytics/models";
import { ANALYTICS_PROVIDER } from "@/features/analytics/models";
import { handleAnalyticsError } from "@/features/analytics/utils";
import { CURRENCY } from "@/shared/models";

const EVERFLOW_ADVERTISER_ID = 1 as const;

export const triggerEverflowEvent = ({
  eventId,
  amount = 0,
  email,
}: EverflowConvertEventParams) => {
  try {
    if (!window?.EF) {
      throw new Error("Everflow not loaded");
    }

    void window.EF.conversion({
      aid: EVERFLOW_ADVERTISER_ID,
      event_id: eventId,
      email,
      amount,
      currency: CURRENCY.USD,
    });
  } catch (error) {
    handleAnalyticsError(error, {
      message: "Error tracking Everflow event",
      provider: ANALYTICS_PROVIDER.EVERFLOW,
      extra: {
        eventId,
        email,
        amount,
      },
    });
  }
};
